import { z } from "zod";

export const bulkUpdateVehicleContractDataResponse = z.object({
  vehiclesUpdatedNb: z.number(),
});

export type BulkUpdateVehicleContractDataResponse = z.infer<
  typeof bulkUpdateVehicleContractDataResponse
>;
